"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Satellites = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
class Satellites extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SATELLITES,
            tags: [Tags_1.Tags.SPACE],
            cost: 10,
            metadata: {
                cardNumber: '175',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.megacredits(1).slash().space().played;
                    });
                }),
                description: 'Increase your M€ production 1 step for each space tag your have, including this one.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1 + player.getTagCount(Tags_1.Tags.SPACE), { log: true });
        return undefined;
    }
}
exports.Satellites = Satellites;
//# sourceMappingURL=Satellites.js.map